(function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class ImageBannerFx extends HTMLElement {
    connectedCallback() {
      this.effect = this.dataset.effect || 'none';
      this.intensity = parseFloat(this.dataset.intensity) || 1;

      if (this.effect === 'none') return;

      if (prefersReducedMotion.matches || (typeof Shopify !== 'undefined' && Shopify.designMode)) {
        this.classList.add('banner-fx--active');
        return;
      }

      this.onMove = this.onMove.bind(this);
      this.onLeave = this.onLeave.bind(this);

      this.addEventListener('pointermove', this.onMove, { passive: true });
      this.addEventListener('pointerdown', this.onMove, { passive: true });
      this.addEventListener('pointerleave', this.onLeave, { passive: true });
      this.addEventListener('pointercancel', this.onLeave, { passive: true });
      this.classList.add('banner-fx--active');
    }

    disconnectedCallback() {
      this.removeEventListener('pointermove', this.onMove);
      this.removeEventListener('pointerdown', this.onMove);
      this.removeEventListener('pointerleave', this.onLeave);
      this.removeEventListener('pointercancel', this.onLeave);
    }

    onMove(event) {
      const rect = this.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      const px = (event.clientX - rect.left) / rect.width;
      const py = (event.clientY - rect.top) / rect.height;
      const i = this.intensity;

      this.style.setProperty('--fx-x', x.toFixed(4));
      this.style.setProperty('--fx-y', y.toFixed(4));
      this.style.setProperty('--fx-px', `${(px * 100).toFixed(2)}%`);
      this.style.setProperty('--fx-py', `${(py * 100).toFixed(2)}%`);
      this.style.setProperty('--fx-intensity', i.toFixed(2));

      if (this.effect === 'depth_tilt') {
        this.style.setProperty('--fx-rotate-y', `${(x * 10 * i).toFixed(2)}deg`);
        this.style.setProperty('--fx-rotate-x', `${(-y * 8 * i).toFixed(2)}deg`);
        this.style.setProperty('--fx-translate-x', `${(x * 18 * i).toFixed(2)}px`);
        this.style.setProperty('--fx-translate-y', `${(y * 14 * i).toFixed(2)}px`);
        this.style.setProperty('--fx-scale', `${(1 + 0.04 * i).toFixed(3)}`);
      }

      if (this.effect === 'spotlight') {
        this.style.setProperty('--fx-spot-size', `${(34 + 8 * i).toFixed(1)}%`);
      }

      if (this.effect === 'ripple_lens') {
        this.style.setProperty('--fx-lens-size', `${(18 + 6 * i).toFixed(1)}%`);
      }
    }

    onLeave() {
      this.style.setProperty('--fx-x', '0');
      this.style.setProperty('--fx-y', '0');
      this.style.setProperty('--fx-rotate-x', '0deg');
      this.style.setProperty('--fx-rotate-y', '0deg');
      this.style.setProperty('--fx-translate-x', '0px');
      this.style.setProperty('--fx-translate-y', '0px');
      this.style.setProperty('--fx-scale', '1');
      this.style.setProperty('--fx-px', '50%');
      this.style.setProperty('--fx-py', '50%');
    }
  }

  if (!customElements.get('image-banner-fx')) {
    customElements.define('image-banner-fx', ImageBannerFx);
  }
})();
